import {Role} from '../message/Role';

export class PseudoRole extends Role {
"@class": string;
}

